/*
 * capitalizes 'string'
 *
 * capitalize('hello') -> 'Hello'
 */

module.exports = function capitalize (string) {
  return string[0].toUpperCase() + string.substring(1)
}
